module.exports = __webpack_public_path__ + "ade613f9e07d2389543d8a53807eb834.svg";